<template>
  <div :class="['content', isRedBg ? 'red-bg' : 'blue-bg']"  style="position: relative;">
     <img src="../../src/assets/titlebg.png" alt="" class="sticky-nav" v-if="!isRedBg">
     <img src="../../src/assets/titlebgRed.png" alt="" class="sticky-nav" v-if="isRedBg">





    <div class="sticky-nav-flex" >
        <p  :class="{ 'active': !isRedBg }"  @click="switchTheme(false)">蓝色版</p>
        <p  :class="{ 'active-red': isRedBg }" @click="switchTheme(true)">红色版</p>
     </div>
    <!-- 全屏容器 -->
    <scale-box style="position: relative;">
      <img src="../../src/assets/titlebg.png" alt="" style="opacity: 0;" >
      <!-- <dv-full-screen-container style="padding: 0 47px;"> -->
      <!-- 第一行 -->
      <!-- <div class="module_box" style="height: 10vh;">
        <div style="flex: 0 1 20%;">
          <dv-decoration-10 style="width:100%;height:50px;" />
        </div>
        <div style="flex: 0 1 40%;">
          <div style="display: flex;width: 100%;">
            <dv-border-box-13  style="height:90px;flex:1"><span class="title">投票数据大屏</span>  </dv-border-box-13>
          </div>
        </div>
        <div style="flex: 0 1 20%;">
          <dv-decoration-10 style="width: 100%;height:50px;transform: rotateY(180deg);" />
        </div>
      </div> -->
      <div v-for="(item, index) in groupList2" :key="index" style="position: absolute;top: -10000px;">
        <span @click="sectionChange(item, index)" style="cursor: pointer;" class="text-span">
          {{ item.group_name }}
        </span>
      </div>
      <!-- 第二行 -->
      <div class="module_box">
        <!-- flex布局 一行四个 各占25% -->
        <!-- 左 -->
        <div style="flex: 0 1 25%;">
          <div class="voteName"  :style="{color:isRedBg?'#ffffff':'#5fd9e8'}" >
            {{ activityInfo.name }}
          </div>
          <div class="timeBox" :style="{backgroundColor:isRedBg?' rgba(255,0,2,0.1)':'rgba(0, 246, 255, 0.1)'}">
            <div class="d_flex">
              <div class="time_title"  :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" >剩余时间</div>
              <div class="end_time">{{ activityInfo.endTimeStr }} 结束</div>
            </div>
            <div class="d_flex1">
              <div class="time_content"  :class="{ 'time_content_red': isRedBg, 'time_content_blue': !isRedBg }">
                {{ countDay }}
              </div>
              <p class="time_type">天</p>
              <div class="time_content"  :class="{ 'time_content_red': isRedBg, 'time_content_blue': !isRedBg }">
                {{ countHour }}
              </div>
              <p class="time_type">时</p>
              <div class="time_content"  :class="{ 'time_content_red': isRedBg, 'time_content_blue': !isRedBg }">
                {{ countMin }}
              </div>
              <p class="time_type">分</p>
              <div class="time_content"  :class="{ 'time_content_red': isRedBg, 'time_content_blue': !isRedBg }">
                {{ countsec }}
              </div>
              <p class="time_type">秒</p>
            </div>
          </div>

          <div class="data_overall" :style="{backgroundColor:isRedBg?' rgba(255,0,2,0.1)':'rgba(0, 246, 255, 0.1)'}">
            <div>
              <p class="overall_num" :style="{color:isRedBg?'rgba(251, 83, 50, 0.75)':'#5fd9e8'}"> {{ activityInfo.signNumber }}</p>
              <p class="overall_tip" >选手数量</p>
            </div>
            <div>
              <p class="overall_num" :style="{color:isRedBg?'rgba(251, 83, 50, 0.75)':'#5fd9e8'}"> {{ activityInfo.sumVotes }}</p>
              <p class="overall_tip"  >投票总数</p>
            </div>
            <div>
              <p class="overall_num" :style="{color:isRedBg?'rgba(251, 83, 50, 0.75)':'#5fd9e8'}"> {{ activityInfo.browseNumber }}</p>
              <p class="overall_tip" >浏览总数</p>
            </div>
          </div>

          <div class="subTitle" :style="isRedBg ? {
            backgroundImage: 'url(' + require('../../src/assets/xiaobiaoti.png') + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            height: '50px',
            display: 'flex',
            alignItems: 'center'
          } : {
            display: 'flex',
            alignItems: 'center'
          }">
            <img src="../../src/assets/icon.png" alt="" width="23" height="23" style="margin-right: 8px;" :style="{opacity:isRedBg?'0':'1'}">
            <p :style="{color:isRedBg?'#fff':'#5fd9e8'}" >近24小时票数增长前5名</p>
          </div>

          <!-- <div id="compositeLeftMiddle">


        </div> -->
          <el-table :data="tableData1" style="width: 100%" :row-class-name="tableRowClassName"
            :header-cell-style='tableHeaderStyle' class="exporttable">
            <el-table-column align="center" prop="ranking" label="当前排名" width="120">
            </el-table-column>
            <el-table-column align="center" prop="Canvasser" label="选手">
              <template slot-scope="scope">
                {{ scope.row.player_num }} 号 - <span style="font-size: 20px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden; text-overflow: ellipsis; word-break: break-all; max-height: 2.4em; line-height: 1.2em;">{{ scope.row.Canvasser }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="count" label="增加票数" width="120">
            </el-table-column>
            <template slot="empty">
              <ul>
                <li v-for="(item, index) in 5" :key="index" :class="getRowClass(index)" style="height: 50px;">

                </li>
              </ul>
            </template>
          </el-table>

          <div class="voteAppName" v-if="alias!='flc7vpv0'">
            <div style="display: flex; align-items: center;justify-content: space-between;">
              <div>
                <p class="title" v-if="appId == 'wx61625ef299496a43'"  :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" >火投票</p>
                <p class="title" v-if="appId == 'wx3a4ad3501b4d2736'"  :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" >投票管家</p>
                <p class="title" v-if="appId == 'wx0bca1de68ed28229'"  :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" >投票100</p>
                <p class="title" v-if="appId == 'wxf390d97b8dc86b13'"  :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" >投票管家</p>
                <p class="title" v-if="appId == 'wxfd39b0c4f1041eec'"  :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" >投票加加</p>

                <div style="display: flex;">
                  <div style="font-size: 22px;color: #fff;letter-spacing: 1.1px; margin-right:112px ;font-weight: bold">
                    <p style="margin-bottom: 10px;">扫码查看</p>
                    <p>投票活动</p>
                  </div>
                  <img src="../../src/assets/jiantou.png" alt="" width="31" height="26">
                </div>
              </div>
              <div class="ewm" >
                <img :src="activityInfo.url" alt="">
              </div>
            </div>

          </div>
        </div>
        <!-- 中 -->

        <div style="flex: 0 1 40%;">
          <div style="display: flex; align-items: center; justify-content: center;height: 50px;margin-top: 22px;">
            <img src='../../src/assets/Previous-red.png' alt="" width="32" height="32" @click="Previous()" v-if="isRedBg">
            <img src= '../../src/assets/Previous.png' alt="" width="32" height="32" @click="Previous()" v-else>
            <div class="d-flex" style="margin: 0 14px;" ref="container">
              <div v-for="(item, index) in groupList" :key="index"
                :class="[
                  index == curNow ? (isRedBg ? 'flex-item-active-red' : 'flex-item-active') : (isRedBg ? 'flex-item-red' : 'flex-item'),
                  groupList.length==1  ? (isRedBg ? 'allgroupred' : 'allgroup')  :''
                ]">
                <div @click="sectionChange(item, index)" style="cursor: pointer;">
                  {{ item.group_name }}
                </div>
              </div>
            </div>
            <img  src="../../src/assets/next-red.png" alt="" width="32" height="32" @click="next()" v-if="isRedBg">
            <img  src="../../src/assets/next.png" alt="" width="32" height="32" @click="next()" v-else>
          </div>
          <!-- <div class="allgroup" v-if="groupList.length == 1">
            全部分组
          </div> -->
          <!-- :style="{ opacity: (tableData3.length < 2 ? '0' : '') }" -->
          <div class="ranking">
            <div class="ranking1" >
              <img src="../../src/assets/yinpai.png" alt="" v-if="rankplayerlist.yin_player_name==''">
              <div style="width: 210px;position: relative;" v-if="rankplayerlist.yin_player_name!=''">
                <div class="topnum">
                  2
                </div>
                <div>
                  <!-- <img class="touxiang" width="70px" src="../../src/assets/tx.png" alt=""> -->
                  <img class="touxiang" width="70px" :src="rankplayerlist.yin_player_img" alt="">
                </div>
                <div class="yin_num">
                  {{ rankplayerlist.yin_player_num }}号
                </div>
                <p class="ranking_info_name">{{ rankplayerlist.yin_player_name }}</p>
                <div class="ranking_info">

                  <p class="ranking_info_result" :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" style="font-size: 26px;">{{ rankplayerlist.yin_get_vote }}票</p>
                </div>
              </div>

            </div>
            <!-- :style="{ opacity: (tableData3.length < 1 ? '0' : '') }" -->
            <div class="ranking2"  >
              <img src="../../src/assets/jinpai.png" alt="" v-show="rankplayerlist.jin_player_name==''">
              <div class="jin" v-show=" rankplayerlist.jin_player_name!=''">
                <img src="../../src/assets/wangguang.png" alt="">
              </div>
              <div v-show=" rankplayerlist.jin_player_name!=''">
                <!-- <img class="touxiang" width="70px" src="../../src/assets/tx.png" alt=""> -->
                <img class="touxiang" width="70px" :src="rankplayerlist.jin_player_img" alt="">
              </div>
              <div class="jin_num" v-show=" rankplayerlist.jin_player_name!=''">
                <!-- {{ tableData3[0].player_num}} -->
                {{ rankplayerlist.jin_player_num }}号
              </div>
              <div class="ranking_info" v-show="rankplayerlist.jin_player_name!=''">
                <p class="ranking_info_name"> {{ rankplayerlist.jin_player_name }}</p>
                <p class="ranking_info_result"   :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" style="font-size: 27px;"> {{ rankplayerlist.jin_get_vote }}票 </p>
              </div>
            </div>


            <!-- :style="{ opacity: (tableData3.length < 3 ? '0' : '') }" -->

            <div class="ranking3" >
              <img src="../../src/assets/tongpai.png" alt="" v-if="rankplayerlist.tong_player_name=='' ">
              <div style="width: 220px; float: right;position: relative;" v-if="rankplayerlist.tong_player_name!=''">
                <div class="topnum">
                  3
                </div>
                <div>
                  <!-- <img class="touxiang" width="70px" src="../../src/assets/tx.png" alt=""> -->
                  <img class="touxiang" width="70px" :src="rankplayerlist.tong_player_img" alt="">
                </div>
                <div class="tong_num">
                  {{ rankplayerlist.tong_player_num }}号
                </div>
                <div class="ranking_info">
                  <p class="ranking_info_name" style="margin-top: 35px; font-size: 20px;">{{rankplayerlist.tong_player_name }}</p>
                  <p class="ranking_info_result"  :style="{color:isRedBg?'#FB5332':'#5fd9e8'}" style="font-size: 26px;">{{ rankplayerlist.tong_get_vote }}票</p>
                </div>
              </div>
            </div>
          </div>
          <div id="compositecCenterMiddle">
            <el-table :data="slicedArray" style="width: 100%" :show-header="false" :row-class-name="tableRowClassName">
              <el-table-column width="80" align="center" prop="player_rank">
              </el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <div class="image-cell">
                    <img :src="scope.row.player_slpic" alt=""
                      style="width: 47px;height: 47px;border-radius: 50%;border: 2px solid #95d7f6;">
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" prop="player_name">
                <template slot-scope="scope">
                  <span style=" font-size: 20px;"> {{ scope.row.player_num }}号-{{ scope.row.player_name }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="get_votes" width="200">
                <template slot-scope="scope">
                  {{ scope.row.get_votes }}票
                </template>
              </el-table-column>
              <template slot="empty">
                <ul>
                <li v-for="(item, index) in 10" :key="index" :class="getRowClass(index)" style="height: 50px;">

                </li>
              </ul>
                <!-- <div
                  style="width: 100%;height: 500px; background-color: #072c65 !important; display: flex;justify-content: center;align-items: center">
                  暂无数据</div> -->
              </template>
            </el-table>


          </div>
        </div>
        <!-- 右 -->
        <div style="flex: 0 1 25%;">
          <div class="subTitle" :style="isRedBg ? {
            backgroundImage: 'url(' + require('../../src/assets/xiaobiaoti.png') + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            height: '50px',
            display: 'flex',
            alignItems: 'center'
          } : {
            display: 'flex',
            alignItems: 'center'
          }">
            <img src="../../src/assets/icon.png" alt="" width="23" height="23" style="margin-right: 8px;" :style="{opacity:isRedBg?'0':'1'}">
            <p  :style="{color:isRedBg?'#fff':'#5fd9e8'}" >排名第11-第20名</p>
          </div>
          <div class="config8" style="height:500px; margin-bottom: 40px;">
            <el-table :data="tableData4" style="width: 100%" :show-header="false" :row-class-name="tableRowClassName" >
              <!-- <el-table-column type="index" :index="indexMethod1" width="80" align="center">
              </el-table-column> -->
              <el-table-column width="80" align="center" prop="player_rank">
              </el-table-column>
              <el-table-column align="left">
                <template slot-scope="scope">

                  {{ scope.row.player_num }}号-{{ scope.row.player_name }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                align="left"
                prop="player_name">
                <template  slot-scope="scope">
                  {{ scope.row.player_name}}
                </template>
              </el-table-column> -->
              <el-table-column align="center" prop="get_votes" width="80">
                <template slot-scope="scope">
                  {{ scope.row.get_votes }}票
                </template>
              </el-table-column>
              <template slot="empty">
                <ul>
                <li v-for="(item, index) in 10" :key="index" :class="getRowClass(index)" style="height: 50px;">

                </li>
              </ul>
                <!-- <div
                  style="width: 100%;height: 500px ;background-color: #072c65 !important; display: flex;justify-content: center;align-items: center">
                  暂无数据</div> -->
              </template>
            </el-table>
          </div>
          <div class="subTitle" :style="isRedBg ? {
            backgroundImage: 'url(' + require('../../src/assets/xiaobiaoti.png') + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            height: '50px',
            display: 'flex',
            alignItems: 'center'
          } : {
            display: 'flex',
            alignItems: 'center'
          }">
            <img src="../../src/assets/icon.png" alt="" width="23" height="23" style="margin-right: 8px;"   :style="{opacity:isRedBg?'0':'1'}">
            <p  :style="{color:isRedBg?'#fff':'#5fd9e8'}" >选手拉票前5名</p>
          </div>
          <div class="config8" style="height:500px; margin-bottom: 80px;">
            <el-table :data="tableData2" :row-class-name="tableRowClassName" :header-cell-style='tableHeaderStyle'>
              <el-table-column align="left" prop="Canvasser" label="选手">
                <template slot-scope="scope">
                  <div style="padding-left: 20px;">{{ scope.row.player_num }} 号 - <span style="font-size: 20px;">{{ scope.row.Canvasser }}</span></div>
                </template>
            </el-table-column>
              <!-- <el-table-column align="center" prop="Canvasser" label="拉票人">
              </el-table-column> -->
              <el-table-column align="center" prop="num" label="分享次数" width="120">
              </el-table-column>
              <template slot="empty">
                <ul>
                  <li v-for="(item, index) in 5" :key="index" :class="getRowClass(index)" style="height: 50px;">

                  </li>
               </ul>
                <!-- <div
                  style="width: 100%;height: 230px; background-color: #072c65 !important; display: flex;justify-content: center;align-items: center">
                  暂无数据</div> -->
              </template>
            </el-table>

            <!-- <dv-scroll-board :config="config5" style="width:100%;height:100%;font-size: 22px" /> -->
          </div>
        </div>
      </div>

      <!--
    </dv-full-screen-container> -->
    </scale-box>
  </div>

</template>

<script charset="UTF-8" id="LA_COLLECT" src="//sdk.51.la/js-sdk-pro.min.js"></script>
<script>LA.init({id:"JVJFtljGzDvx9bLa",ck:"JVJFtljGzDvx9bLa"})</script>
<script>
import instance from '../api/http.js';
//  import bigScreenAdapterMixin from "../utils/drawMixin";
import ScaleBox from '../../src/components/SacleBox/index.vue';
export default {
  name: 'Homediv',

  // mixins: [bigScreenAdapterMixin],
  data() {
    return {
      interval1: null,
      cleardata: null,
      activityInfo: {
        name: '',
        endTimeStr: '',
        browseNumber: '',
        signNumber: '',
        sumVotes: '',
        url: '',
      },
      basicInformationLoaded: false,
      rawGroupList: null,
      groupId: '',
      voteAppName: '火投票',
      tableData1: [],
      tableData2: [],
      tableData3: [],
      groupList: [],
      curNow: 0,				//tab栏切换
      endTime: '',
      countDay: '',
      countHour: '',
      countMin: '',
      countsec: '',
      rankplayerlist: {
        jin_player_num: '',
        jin_player_name: '',
        jin_get_vote: '',
        jin_player_img: '',
        yin_player_num: '',
        yin_player_name: '',
        yin_get_vote: '',
        yin_player_img: '',
        tong_player_num: '',
        tong_player_name: '',
        tong_get_vote: '',
        tong_player_img: '',

      },
      groupList2: [],
      largeScreenToken: '',
      commontGroupID: '',
      groupListPage: 1,
      emptyData1:[{
        name:'',
        id:1
      },
      {
        name:'',
        id:1
      },
      {
        name:'',
        id:1
      },
      {
        name:'',
        id:1
      },
      {
        name:'',
        id:1
      },
      {
        name:'',
      }],
      alias:'',
      appId:'',
      isRedBg: localStorage.getItem('theme') === 'red', // 从本地存储读取主题设置
    }
  },
  components: {
    ScaleBox,
  },
  created() {
    this.largeScreenToken = this.$route.query.largeScreenToken
    this.alias = this.$route.query.alias
    this.appId =  localStorage.getItem('appId')
    console.log(this.appId,'appId')
    localStorage.setItem('largeScreenToken', this.largeScreenToken);
    console.log(this.largeScreenToken, 'largeScreenToken')
    this.init()
    this.getvoteGrowth()
    this.getvoteSolicitationRank()
    this.getGroupList()

    this.cleardata = setInterval(() => {
      this.init()
      this.getvoteGrowth()
      this.getvoteSolicitationRank()
      // this.getGroupList()
    }, 10000)

    this.interval1 = setInterval(() => {
      this.getPlayerList()
    }, 10000)


  },
  methods: {
    switchTheme(isRed) {
      this.isRedBg = isRed;
      localStorage.setItem('theme', isRed ? 'red' : 'blue');
    },
    getRowClass(index) {
      console.log(index,'index')
      if (this.isRedBg) {
        return index % 2 === 0 ? 'even-row-red' : 'odd-row-red';
      }
      return index % 2 === 0 ? 'even-row' : 'odd-row';
    },

    indexMethod(index) {
      return index + 4;
    },
    indexMethod1(index) {
      return index + 11;
    },
    async init() {
      instance.post('largeScreen/basicInformation',{
        headers: {
            'Access-Token': `Bearer ${localStorage.getItem('largeScreenToken')}`, // 假设 token 存储在 localStorage 中
            'Custom-Header': 'foobar' // 添加一个自定义的头部
          }
      })
        .then(async response => {
          // 处理响应
          if (response.data.status == 501) {
            this.$message({
              message: 'token已过期',
              type: 'error',
              onClose: () => {

                this.$router.push({
                  path: '/',
                  query: { alias: localStorage.getItem('alias') }
                })
              }
            });
            return false;
          }
          const groupAllChanged = !this.basicInformationLoaded ||
            (Number(this.activityInfo.groupAll) === 2) !== (Number(response.data.data.groupAll) === 2)
          this.activityInfo = response.data.data
          this.basicInformationLoaded = true
          if (groupAllChanged) {
            this.updateGroupList()
          }
          this.endTime = this.activityInfo.endTimeStr;
          // this.endTime = this.endTime.replace(/-/g, "/");
          await this.countDown();
          console.log(response)
        })
        .catch(error => {
          // 处理错误
          console.log(error)
        });
    },
    getvoteGrowth() {
      instance.post('largeScreen/voteGrowth')
        .then(response => {
          // 处理响应
          if (response.data.status == 501) {
            this.$message({
              message: 'token已过期',
              type: 'error',
              onClose: () => {

                this.$router.push({
                  path: '/',
                  query: { alias: localStorage.getItem('alias') }
                })
              }
            });
            return false;
          }

          response.data.data.forEach((item) => {
            console.log(item, '123')
            if (item.player_name.search("-") != -1) {
              var arr = item.player_name.split('-');
              item.Canvasser = arr[0]

              console.log(item.Canvasser, ' item.Canvasser')
            } else {
              item.Canvasser = item.player_name
              console.log(item.Canvasser, ' item.Canvasser')
            }

          });

          this.tableData1 = response.data.data

        })
        .catch(error => {
          // 处理错误
          console.log(error)
        });
    },
    getvoteSolicitationRank() {
      instance.post('largeScreen/voteSolicitationRank')
        .then(response => {

          if (response.data.status == 501) {
            this.$message({
              message: 'token已过期',
              type: 'error',
              onClose: () => {

                this.$router.push({
                  path: '/',
                  query: { alias: localStorage.getItem('alias') }
                })
              }
            });
            return false;
          }
          console.log('hhhhh', response)
          // 处理响应
          response.data.data.forEach((item) => {
            console.log(item, '123')
            if (item.player_name.search("-") != -1) {
              var arr = item.player_name.split('-');
              item.Canvasser = arr[0]

              console.log(item.Canvasser, ' item.Canvasser')
            } else {
              item.Canvasser = item.player_name
              console.log(item.Canvasser, ' item.Canvasser')
            }

          });
          this.tableData2 = response.data.data


        })
        .catch(error => {
          // 处理错误
          console.log(error)
        });
    },
    getGroupList() {
      instance.post('largeScreen/getGroupList')
        .then(response => {
          // 处理响应
          if (response.data.status == 501) {
            this.$message({
              message: 'token已过期',
              type: 'error',
              onClose: () => {

                this.$router.push({
                  path: '/',
                  query: { alias: localStorage.getItem('alias') }
                })
              }
            });
            return false;
          }
          this.rawGroupList = response.data.data
          this.updateGroupList()

        })
        .catch(error => {
          // 处理错误
          console.log(error)
        });
    },

    updateGroupList() {
      // 两个接口并行返回，等基础信息和分组都就绪后再确定按钮及默认分组。
      if (!this.basicInformationLoaded || this.rawGroupList === null) return

      const showAllGroups = Number(this.activityInfo.groupAll) === 2
      this.groupList2 = showAllGroups
        ? [{ group_name: '全部分组', group_order_by: '', id: '' }, ...this.rawGroupList]
        : [...this.rawGroupList]
      console.log('[largeScreen] 更新分组开关', {
        groupAll: this.activityInfo.groupAll,
        showAllGroups,
        groupCount: this.groupList2.length
      })

      this.$nextTick(() => {
        // 开关更新时保留仍然可用的分组，否则切换到第一项。
        const selectedIndex = this.groupList2.findIndex(item => item.group_order_by === this.groupId)
        this.setGroupList(0, 'next')
        if (this.groupList.length) {
          let pageIndex = this.groupList.indexOf(this.groupList2[selectedIndex])
          if (selectedIndex >= 0 && pageIndex < 0) {
            this.setGroupList(selectedIndex, 'next')
            pageIndex = 0
          }
          this.curNow = Math.max(pageIndex, 0)
          this.sectionChange(this.groupList[this.curNow], this.curNow)
        } else {
          this.groupId = ''
          this.clearplayerData()
          this.getPlayerList()
        }
      })
    },
    setGroupList(startIndex, type) {
      const groupNames = document.getElementsByClassName('text-span')
      const step = type === 'next' ? 1 : -1
      const page = []
      let width = 0

      for (let i = startIndex; i >= 0 && i < this.groupList2.length; i += step) {
        const group = this.groupList2[i]
        const lineWidth = groupNames[i].offsetWidth + group.group_name.length * 0.51 + 40
        // 超长分组名也至少显示一项，避免出现无法翻页的空列表。
        if (page.length && width + lineWidth > 650) break
        width += lineWidth
        if (step === 1) {
          page.push(group)
        } else {
          page.unshift(group)
        }
      }

      this.groupList = page
      this.curNow = type === 'next' ? 0 : Math.max(page.length - 1, 0)
    },
    getPlayerList(groupId = this.groupId) {
      console.log(groupId, '分组id')
      var params = {
        pageNum: 1,
        pageSize: 20,
        groupId: groupId == null ? '' : groupId,
      };

      var queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
      instance.post(
        'largeScreen/getPlayerList?' + queryString, {},

      ).then(response => {
        if (response.data.status == 501) {
          this.$message({
            message: 'token已过期',
            type: 'error',
            onClose: () => {

              this.$router.push({
                path: '/',
                query: { alias: localStorage.getItem('alias') }
              })
            }
          });
          return false;
        }
        // 切换分组后丢弃旧分组响应，避免全量数据覆盖当前分组。
        if (groupId !== this.groupId) return
        // 处理响应rankplayerlist
        response.data.data.list.map((res,i)=>{
            this.$set(res,'player_rank',i+1)
        })
        this.tableData3 = response.data.data.list
        if(this.tableData3.length==0){
              this.rankplayerlist.jin_player_num = ''
              this.rankplayerlist.jin_player_name = ''
              this.rankplayerlist.jin_get_vote =''
              this.rankplayerlist.jin_player_img = ''
              this.rankplayerlist.yin_player_num = ''
              this.rankplayerlist.yin_player_name = ''
              this.rankplayerlist.yin_get_vote = ''
              this.rankplayerlist.yin_player_img = ''
              this.rankplayerlist.tong_player_num = ''
              this.rankplayerlist.tong_player_name = ''
              this.rankplayerlist.tong_get_vote = ''
              this.rankplayerlist.tong_player_img = ''
          }

        if (this.tableData3.length > 0) {
          this.tableData3.map((item, idx) => {
            if (idx == 0) {
                this.rankplayerlist.jin_player_num = item.player_num
                this.rankplayerlist.jin_player_name = item.player_name
                this.rankplayerlist.jin_get_vote = item.get_votes
                console.log(this.rankplayerlist.jin_get_vote, 'this.rankplayerlist.jin_get_vote')
                this.rankplayerlist.jin_player_img = item.player_slpic
              } else if (idx == 1) {
                this.rankplayerlist.yin_player_num = item.player_num
                this.rankplayerlist.yin_player_name = item.player_name
                this.rankplayerlist.yin_get_vote = item.get_votes
                this.rankplayerlist.yin_player_img = item.player_slpic
              } else if (idx == 2) {
                this.rankplayerlist.tong_player_num = item.player_num
                this.rankplayerlist.tong_player_name = item.player_name
                this.rankplayerlist.tong_get_vote = item.get_votes
                this.rankplayerlist.tong_player_img = item.player_slpic
              }
          })
        }

      })
        .catch(error => {
          // 处理错误
          console.log(error)
        });
    },
    //切换分组
    sectionChange(item, index) {
      this.curNow = index;
      this.groupId = item.group_order_by
      this.clearplayerData()
      this.getPlayerList()
    },
    Previous() {
      if (!this.groupList.length) return
      if (this.curNow === 0) {
        const firstIndex = this.groupList2.indexOf(this.groupList[0])
        if (firstIndex <= 0) return
        this.setGroupList(firstIndex - 1, 'previous')
      } else {
        this.curNow -= 1
      }
      this.sectionChange(this.groupList[this.curNow], this.curNow)
    },
    next() {
      if (!this.groupList.length) return
      if (this.curNow === this.groupList.length - 1) {
        const lastIndex = this.groupList2.indexOf(this.groupList[this.curNow])
        if (lastIndex >= this.groupList2.length - 1) return
        this.setGroupList(lastIndex + 1, 'next')
      } else {
        this.curNow += 1
      }
      this.sectionChange(this.groupList[this.curNow], this.curNow)
    },
    clearplayerData(){
      this.rankplayerlist.jin_player_num = ''
      this.rankplayerlist.jin_player_name = ''
      this.rankplayerlist.jin_get_vote =''
      this.rankplayerlist.jin_player_img = ''
      this.rankplayerlist.yin_player_num = ''
      this.rankplayerlist.yin_player_name = ''
      this.rankplayerlist.yin_get_vote = ''
      this.rankplayerlist.yin_player_img = ''
      this.rankplayerlist.tong_player_num = ''
      this.rankplayerlist.tong_player_name = ''
      this.rankplayerlist.tong_get_vote = ''
      this.rankplayerlist.tong_player_img = ''
    },
    tableRowClassName({ rowIndex }) {
      if (this.isRedBg) {
        return rowIndex % 2 === 0 ? 'even-row-red' : 'odd-row-red';
      }
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    tableHeaderStyle({row,column,rowIndex,columnIndex}) {
      const bgColor = this.isRedBg ? '#8E0F02 !important' : '#0A4075';
      if(rowIndex===0 && columnIndex===0){
        return `background-color:${bgColor};color:#fff;font-weight:700;font-size:20px;height:52px;padding-left:20px`;
      }else{
        return `background-color:${bgColor};color:#fff;font-weight:700;font-size:20px;height:52px`;
      }
    },
    tableHeaderRowClassName() {
      return 'table-header'
    },
    timeFormat(param) {
      return param < 10 ? '0' + param : param;
    },
    countDown() {
      var interval = setInterval(() => {
        // 获取当前时间，同时得到活动结束时间数组
        let newTime = new Date().getTime();

        // 对结束时间进行处理渲染到页面
        let endTime = new Date(this.endTime).getTime();
        let obj = null;
        // 如果活动未结束，对时间进行处理
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000;
          // 获取天、时、分、秒
          let day = parseInt(time / (60 * 60 * 24));
          let hou = parseInt(time % (60 * 60 * 24) / 3600);
          let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
          let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
          obj = {
            day: this.timeFormat(day),
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec)
          };
        } else { // 活动已结束，全部设置为'00'
          obj = {
            day: '00',
            hou: '00',
            min: '00',
            sec: '00'
          };
          clearInterval(interval);
        }
        this.countDay = obj.day
        this.countHour = obj.hou
        this.countMin = obj.min
        this.countsec = obj.sec
        this.countDownList = obj.day + '天' + obj.hou + '时' + obj.min + '分' + obj.sec + '秒';
      }, 1000);
    },

  },
  mounted() {

    // 在组件内部

  },
  watch: {
    endtime(newval, oldval) {
      console.log(oldval)
      if (newval) {
        this.countDown();
      }
    }
  },
  computed: {
    slicedArray() {
      return this.tableData3.slice(3, 10);
    },
    tableData4() {
      return this.tableData3.slice(10, 20);
    },

  },
  destroyed() {
    clearInterval(this.cleardata)
    clearInterval(this.interval1)
  },

}
</script>

<style lang="scss">
body {
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
}

.sticky-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  /* 样式调整为吸顶效果 */
}
 .sticky-nav-red{
    width: 293px;
    height: 46px;
    background: linear-gradient(0deg, #ffdcd3 0%, #ffffff 100%);
    font-size: 46px;
    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
    font-weight: 700;
    text-align: left;
    color: #ff8033;
    letter-spacing: 3.68px;
 }


.el-table td.el-table__cell {
  border: 0;
}

.exporttable {
  border: none !important;
  border-color: transparent
}

.el-table tbody tr {
  pointer-events: none;
}


#compositecCenterMiddle {
  height: 500px;
  text-align: center;
  font-size: 22px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  line-height: 42px;
  margin-top: 19px;

}

#compositeLeftMiddle {
  height: 400px;
  text-align: center;
  margin-bottom: 40px;



}

.el-table .even-row {
  background: #0C2761 !important;
  font-size: 18px !important;
  color: #ffffff !important;
  height: 35px;

}

.el-table .odd-row {
  background: #0A4075 !important;
  font-size: 18px !important;
  color: #ffffff !important;
  height: 35px;
}

.el-table .even-row-red {
  background: rgba(255,0,2,0.1) !important;
  font-size: 18px !important;
  color: #ffffff !important;
  height: 35px;
}

.el-table .odd-row-red {
  background: rgba(255,0,2,0.21) !important;
  font-size: 18px !important;
  color: #ffffff !important;
  height: 35px;
}
.el-table .header-row-class-name {
  background-color: #0A4075 !important;
  font-size: 16px !important;
  color: #ffffff !important;
}

.container {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
}



#dv-full-screen-container {
  height: calc(100vh - 65px) !important;
}

.title {
  /* background: linear-gradient(1deg,#4ed5e5 0%, #ffffff 100%); */
  font-size: 44px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: bold;
  text-align: center;
  color: #5FD9E8;
  letter-spacing: 2.2px;
  background-clip: text;

}

.voteName {
  /* width: 420px; */
  font-size: 30px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: bold;
  text-align: left;
  color: #5fd9e8;
  letter-spacing: 1.4px;
  line-height: 36px;
  margin-bottom: 29px;
}

.timeBox {
  background: rgba(0, 246, 255, 0.1);
  border-radius: 6px;
  margin-bottom: 20px;
  padding: 26px 23px
}

.d_flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.time_title {
  font-size: 22px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  color: #5fd9e8;
  letter-spacing: 1.77px;
}

.end_time {
  font-size: 20px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  letter-spacing: 1.6px;
}

.d_flex1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 39px;
}

.time_content {

  width: 59px;
  height: 63px;
  background-size: contain;
  background-repeat: no-repeat;
  line-height: 63px;
  text-align: center;
  color: #fff;
  font-size: 39px;
  font-weight: 700;

}
.time_content_red {
  background-image: url(../assets/timeRedbg.png);
}

.time_content_blue {
  background-image: url(../assets/redBox.png);
}

.time_type {
  font-size: 22px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  color: #fefeff;
  letter-spacing: 1.32px;
}

.data_overall {
  background: rgba(0, 246, 255, 0.1);
  border-radius: 6px;
  padding: 25px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
}

.overall_num {
  font-size: 32px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  color: #5fd9e8;
  margin-bottom: 16px
}

.overall_tip {
  font-size: 22px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.subTitle {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  color: #5fd9e8;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.ranking {
  width: 684px;
  display: flex;
  justify-content: space-between;
  margin: 93px auto 0;
  position: relative;
  text-align: center;
}

.ranking1 {
  width: 319px;
  height: 223px;
  position: relative;
}

.ranking1 .num {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  margin-top: 8px;
}


.ranking1 .touxiang {
  width: 84px;
  height: 84px;
  margin-top: 22px;
  border-radius: 50%;
  border: 3px solid #dfdfdf;
}

.ranking2 {
  width: 253px;
  height: 314px;
  position: absolute;
  left: 210px;
  bottom: 0px;
  z-index: 1;
}

.ranking2 .touxiang {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 4px solid #fff053;
  margin-top: 56px;
}

.ranking2 .num {
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  margin-top: 4px;
}

.ranking2 .ranking_info_name {
  font-size: 24px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  // height: 40px;
  line-height: 30px;
  text-align: center;
  color: #ffffff;
  margin-top: 18px;
  margin-bottom: 8px;
  /* line-height: 34px; */
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
  // word-break: break-all;

}

.ranking3 {
  width: 321px;
  height: 224px;
  position: relative;
}

.ranking3 .touxiang {
  width: 84px;
  height: 84px;
  margin-top: 22px;
  border-radius: 50%;
  border: 3px solid #ac8567;
}

.ranking3 .num {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  margin-top: 8px;
}

.ranking_info_name {
  font-size: 22px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  margin-bottom: 11px;
  margin-top: 32px;
  line-height: 25px;
}

.ranking_info_result {
  // width: 117px;
  height: 25px;
  font-size: 26px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  color: #5fd9e8;
  letter-spacing: 2.59px;
}

.allgroup {
  padding: 0 22px ;
  height: 46px;
  line-height: 42px;
  text-align: center;
  border: 2px solid #00F6FF;
  color: #00F6FF;
  margin: 0 auto;
  border-radius: 10px !important;

}
.allgroupred{
  padding: 0 22px ;
  height: 46px;
  line-height: 42px;
  text-align: center;
  border: 2px solid #EC0710;
  color: #fff;
  margin: 0 auto;
  border-radius: 10px !important;



}
.text-span {

  color: #00F6FF;
  font-size: 20px;
  font-weight: 700;

}



.d-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
  //width: 100%;

  .flex-item {
    padding: 0 20px;
    height: 46px;
    line-height: 42px;
    text-align: center;
    border: 2px solid #00F6FF;
    color: #00F6FF;

  }

  .flex-item-active {
    padding: 0 20px;
    height: 46px;
    line-height: 42px;
    text-align: center;
    background-color: #5FD9E8;
    border: 2px solid #00F6FF;
    color: #162066;
  }

}

.d-flex :first-child {
  border-radius: 12px 0px 0px 12px;
}

.d-flex :last-child {
  border-radius: 0 12px 12px 0;
}

.yin {
  text-align: center;
  position: absolute;
  top: 9px;
  width: 34px;
  height: 32px;
  z-index: 0;
  left: 58px;
}

.jin {
  text-align: center;
  position: absolute;
  top: 23px;
  width: 70px;
  height: 67px;
  left: 32px;
  z-index: 0;
}

.tong {
  text-align: center;
  position: absolute;
  top: 10px;
  width: 34px;
  height: 33px;
  z-index: 0;
  left: 163px;

}

.jin img,
.yin img,
.tong img {
  width: 100%;
  height: 100%;
}

.jin_num {
  width: 94px;
  height: 37px;
  background: #fff053;
  border-radius: 17px;
  font-size: 27px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  color: #9c9120;
  line-height: 37px;
  position: absolute;
  bottom: 35%;
  left: 32%;

}

.yin_num {
  width: 67px;
  height: 26px;
  background: #DFDFDF;
  border-radius: 17px;
  font-size: 19px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  color: #606266;
  line-height: 26px;
  position: absolute;
  bottom: 46%;
  left: 35%;
}

.tong_num {
  width: 67px;
  height: 26px;
  background: #ac8567;
  border-radius: 12px;
  font-size: 19px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  line-height: 26px;
  color: #fff;
  position: absolute;
  bottom: 45%;
  left: 36%;
}

.topnum {
  color: #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 75px;
  top: -15px;
  font-size: 24px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  letter-spacing: 2.38px;
}

.voteAppName {
  margin-top: 20px;
  position: fixed;
  //bottom: 17px;
  width: 24%;

  .title {
    width: 217px;
    height: 34px;
    font-size: 28px;
    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
    font-weight: bold;
    text-align: left;
    color: #5fd9e8;
    letter-spacing: 1.69px;
    margin-bottom: 34px;
  }

  .ewm {
    width: 145px;
    height: 145px;
    background: #ffffff;
    border-radius: 20px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
}

.el-table {
  background-color: rgba(255, 255, 255, 0) !important;
}

.el-table::before {
  background-color: transparent !important;
}

.el-table .image-cell {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  /* 根据你的需求调整高度 */
}

.el-table .image-cell img {
  max-height: 100%;
  /* 确保图片不会超过单元格高度 */
  max-width: 100%;
  /* 确保图片不会超过单元格宽度 */
}

.el-table th.el-table__cell.is-leaf {
  border-color: rgba(255, 255, 255, 0);
}

.el-table tr {
  border-color: rgba(255, 255, 255, 0);
}

.el-table td {
  border-color: rgba(255, 255, 255, 0);
}

.el-table__empty-text {
  height: 100%;
  color: #909399;
  width: 100%;
}

.list-container {
  display: flex;
  overflow-x: auto;
}

.list-item {
  width: calc(33.33% - 10px);
  /* 假设每个项之间有10px的间隙 */
  margin-right: 10px;
  box-sizing: border-box;
}

.scroll-view_x {
  width: 70%;
  margin: 0 auto;
  /* padding: 0 20px; */
  margin-bottom: 20px;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  position: relative;

  .allbtn {
    /* width: 100%; */
    display: flex;
    align-items: center;

    .flex-item {
      padding: 0 20px;
      height: 46px;
      line-height: 42px;
      text-align: center;
      border: 2px solid #00F6FF;
      color: #00F6FF;

    }

    .flex-item-active {
      padding: 0 22px;
      height: 46px;
      line-height: 42px;
      text-align: center;
      background-color: #5FD9E8;
      border: 2px solid #00F6FF;
      color: #162066;
    }
  }

  .flex-item-red {
    padding: 0 22px;
    height: 46px;
    line-height: 42px;
    text-align: center;
    border: 2px solid #E2252B;
    color: #fff ;
  }




}
.flex-item-active-red {
  padding: 0 22px;
  height: 46px;
  line-height: 42px;
  text-align: center;
  background-color: #E2252B;
  border: 2px solid #E2252B;
  color: #fff;
}
.sticky-nav-flex{
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  position: absolute;
  top: 20px;
  right: 50px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  padding: 2px;
  z-index: 1005;

  p {
    padding: 2px 10px;
    font-size: 14px;
    cursor: pointer;
    color: #fff;
    border-radius: 2px;
    margin: 0;

    &.active-red {
      background: #FB5332;
      border: 1px solid #FB5332;
    }
    &.active {
      background: #0a4075;
      border: 1px solid #0a4075;
    }
  }
}
.sticky-nav-div {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  font-size: 40px;
  font-weight: bold;
  color: transparent;
  background: linear-gradient(0deg,#ffdcd3 0%, #ffffff 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
